<template>
  <BaseDialog
    :model-value="model"
    :title="'Cadastrar Usuário'"
    :icon="'mdi-account-plus'"
    :loading="loading"
    @salvar="salvarUsuario"
    max-width="420"
  >
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="usuario.username"
        label="Usuário"
        :rules="[rules.required]"
        prepend-inner-icon="mdi-account"
        required
        class="mb-3"
      />
      <v-text-field
        v-model="usuario.email"
        label="E-mail"
        :rules="[rules.required, rules.email]"
        prepend-inner-icon="mdi-email"
        required
        class="mb-3"
      />
      <v-text-field
        v-model="usuario.password"
        label="Senha"
        :rules="[rules.required, rules.minLength(6)]"
        prepend-inner-icon="mdi-lock"
        :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
        :type="showPassword ? 'text' : 'password'"
        @click:append-inner="showPassword = !showPassword"
        required
        class="mb-2"
      />
    </v-form>
  </BaseDialog>
</template>

<script>
import api from "@/services/api";
import rulesMixin from "@/mixins/rulesMixin";
import { mapActions } from "vuex";
import BaseDialog from "./comum/BaseDialog.vue";

export default {
  mixins: [rulesMixin],
  components: { BaseDialog },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    model: false,
    valid: false,
    loading: false,
    showPassword: false,
    usuario: {
      username: "",
      email: "",
      password: "",
    },
  }),
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        this.model = val;
      },
    },
    model(val) {
      this.$emit("update:modelValue", val);
      if (!val) this.resetar();
    },
  },
  methods: {
    ...mapActions(["triggerFeedback"]),
    resetar() {
      this.usuario = { username: "", email: "", password: "" };
      this.valid = false;
      this.showPassword = false;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    fechar() {
      this.model = false;
    },
    async salvarUsuario() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      this.loading = true;
      try {
        await api.post("/usuarios/", this.usuario);
        this.$emit("update:modelValue", false);
        this.$emit("usuario-cadastrado");
        this.triggerFeedback({
          message: "Usuário cadastrado com sucesso!",
          color: "success",
          icon: "mdi-check-circle",
        });
      } catch (error) {
        this.triggerFeedback({
          message: "Erro ao cadastrar usuário!",
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
      this.loading = false;
    },
  },
};
</script>
